export const AjaxRequest = {
	create: (url) => {
		return new Promise((resolve, reject) => {
			let request = new XMLHttpRequest();

			request.open('GET', url);
			request.send();
			request.onreadystatechange = function () {
				if (request.readyState === 4) {
					if (request.status === 200) {
						resolve(JSON.parse(request.response));
					} else {
						reject(request.status);
						throw new Error(request.response);
					}
				}
			};
		});
	},

	handleError: (status) => {
		console.log('failed with status', status)
	}
};
